let mobileBreakpoint = 576;
let loaderImage = './../images/loading.gif';
let loaderImageSynexus = './../images/loading-synexus.gif';
let loaderImagePPD = './../images/loading-ball-purple.gif';
let analyseImage = './../images/analyze.gif';
let analyseImageSynexus = './../images/analyze-synexus.gif';
let deviceDetails;
let isMobilePixel;
let hideInfo;
let rowInfo;

function detectDevice() {
  var b = navigator.userAgent.toLowerCase(),
    a = function (a) {
      if (a) {
        b = (a + "").toLowerCase();
      }
      return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(b) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(b) ? "phone" : "desktop";
    };
  return {
    device: a(),
    detect: a,
    isMobile: "desktop" !== a() ? !0 : !1,
    userAgent: b
  };
}

//Tooltip
$(document).ready(function () {
  $('#screener-container .loader').addClass('show-loader');

  deviceDetails = detectDevice();
  isMobilePixel = deviceDetails.isMobile;

  $(window).resize(function(){
    deviceDetails = detectDevice();
    isMobilePixel = deviceDetails.isMobile;
    hideInfo = 'd-none col-2';
    rowInfo= 'col-lg-12 col-10 col-md-12';
    if(isMobilePixel){
      hideInfo = 'd-inline col-2';
      rowInfo= 'col-lg-10 col-10 col-md-10';
    }
    handleFaIcon();
    tooltipResizerChk();
    tooltipResizerChkQstn();
  });

  function handleFaIcon(){
      //Handling answer level resize
      $('.rowInfo').siblings('div.row').children('div:not(#centerFaIcon)').removeClass();
      $('.rowInfo').children(':odd').removeClass();
      $('.rowInfo').siblings('div.row').children('div:not(#centerFaIcon)').addClass(rowInfo);
      $('.rowInfo').children(':odd').addClass(hideInfo);

      //Handling question level resize
      $('.hideFaInfo').children().eq(0).removeClass().addClass(rowInfo);
      $('.hideFaInfo').children().eq(1).removeClass().addClass(hideInfo);

  }

  function tooltipResizerChk(){
    const isAnyHasGlossaryData = $(".answers-container div.row").find("button").find('.glossary-tooltip-mobile').hasClass('glossary-tooltip-mobile');
    $(".answers-container").find("div.row").each(function(){
        if(window.matchMedia('(max-width: 767px)').matches || (isMobilePixel)){
          $('.tooltip').remove(); 
          $(this).find(".glossary-tooltip-mobile").removeClass("glossary");
          $(this).find(".glossary-tooltip-mobile").css("text-decoration", "underline");
          let divHeight = $(this).find("button").innerHeight();
          if($.isNumeric(divHeight)){
            $(this).find("i.fa.fa-question-circle").parent().css("margin-top",divHeight/2);
            if(isAnyHasGlossaryData){
                $(this).css("height",divHeight+20);
            }
          }
        }else{
          $(this).find(".glossary-tooltip-mobile").addClass("glossary");
          $('[data-toggle="tooltip"]').tooltip();
          $(this).removeAttr('style');
          $('body').find('.modal').filter( function(){
            let isGlossaryTootip = $(this).attr('id').match(/glossaryTextModal/);
            if(isGlossaryTootip != null){
              const modalId = $(this).attr('id');
              $('#'+modalId).modal('hide');
            }
        })
        }
      })
  }

  function tooltipResizerChkQstn(){

    $(".question-text").each(function(){
      const glossaryThis = $(this).find(".glossary-tooltip-mobile");
      if(window.matchMedia('(max-width: 767px)').matches || (isMobilePixel)){
        $('.tooltip').remove();
        glossaryThis.removeClass("glossary");
        glossaryThis.css("text-decoration", "underline");
        let divHeight = $(this).innerHeight()/2;
        let copyRowInfo = rowInfo;
        copyRowInfo = copyRowInfo.replace(/ /g, '.');
        let copyHideInfo = hideInfo;
        copyHideInfo = copyHideInfo.replace(/ /g, '.');
        $(this).parents(`div.${copyRowInfo}`).eq(0).siblings(`div.${copyHideInfo}`).eq(0).css("margin-top",divHeight);
      }else{
        glossaryThis.addClass("glossary");
        $('[data-toggle="tooltip"]').tooltip();
      }
    })
}

  $('[data-toggle="tooltip"]').tooltip(); //Setup element events

  $("#questions").on("click", ".answer-option-container", function () {
    var parent = $(this).parent().get(0);
    if($(parent).attr('class').includes('col-10') == true){
      parent = $(this).parents().get(2);
      if ($(this).parents().get(2).classList.contains("single-choice-answers-container")) {
        onAnswerOptionSingleChoiceClicked(this, parent);
      }
      else if ($(this).parents().get(2).classList.contains("multiple-choice-answers-container")) onAnswerOptionMultipleChoiceClicked(this, parent);
    }else{
      if ($(this).parent().get(0).classList.contains("single-choice-answers-container")) {
        onAnswerOptionSingleChoiceClicked(this, parent);
      }
      else if ($(this).parent().get(0).classList.contains("multiple-choice-answers-container")) onAnswerOptionMultipleChoiceClicked(this, parent);
    }
  });

  //Add event for answer options with autosubmit class after
  $("#questions").on("click", ".autosubmit", function () { submitData() });

  $(".glossary").each(function () {
    $(this).mouseover(function () {
      showTooltip("HOVER TEXT");
    });
  });
}); //On submit button clicked
//  $( "#question-answers-container" ).effect( 'slide', {direction: "up", distance: 1000}, 1500);

function questionOutAnimation(studySearchQuestion = false) {

  if (window.screen.width > mobileBreakpoint) {
    $("#questions-form").addClass("animated fadeOut faster"); //animate out and empty div
  } else {
    $("#questions-form").addClass("animated fadeOutUp fast"); //animate out and empty div
  }
  $("#questions-form").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {

    // show different loading image for synexus/non synexus and searching study question/general question
    if (ppdFlag) {
      $('.loader-gif').attr('src', loaderImagePPD);
    }
    else {
      if (studySearchQuestion && synexusFlag) {
        $('.loader-gif').attr('src', analyseImageSynexus);
      }
      else if (studySearchQuestion && !synexusFlag) {
        $('.loader-gif').attr('src', analyseImage);
      }
      else if (!studySearchQuestion && synexusFlag) {
        $('.loader-gif').attr('src', loaderImageSynexus);
      }
      else {
        $('.loader-gif').attr('src', loaderImage);
      }
    }

    // add class to main container so loader gif can be seen
    $('#screener-container .loader').addClass('show-loader');
    //First delete current generated divs
    $("#questions").empty(); //Hide container too to hide buttons and other things
    $("questions-form").hide(); //show previous button after passing first question
    $("#previous").css("display", "block");
    returnRandomImage();

    //Animate the content container when its height changes for a smooter UX.
    var totalHeight = 0 + $('#screener-container .loader').outerHeight();  //calculate an the empty container (no question content) + the hidden questionContainer height
    $('#screener-container').animate({ "min-height": totalHeight }, 300, 'linear');
  });
}

function finishQuestionOutAnimation() {

  //Remove both classes, in case user rotates mobile while animation class is on
  $("#questions-form").removeClass("animated fadeOut faster");
  $("#questions-form").removeClass("animated fadeOutUp fast");

  $("#questions-form").off("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend");
}

function questionInAnimation() {
  $('#screener-container .loader').removeClass('show-loader');

  //Remove both classes, in case user rotates mobile while animation class is on
  $("#questions-form").removeClass("animated fadeOut faster");
  $("#questions-form").removeClass("animated fadeOutUp fast");

  if (window.screen.width > mobileBreakpoint) {
    $("#questions-form").addClass("animated fadeIn faster");
  } else {
    $("#questions-form").addClass("animated fadeInUp fast");
  }
  $("#questions-form").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", onSlideInEnd);

}

function onSlideInEnd() {
  if (window.screen.width > mobileBreakpoint) {
    $("#questions-form").removeClass("animated fadeIn faster");
  } else {
    $("#questions-form").removeClass("animated fadeInUp fast");
  }
} //Option clicked


function onAnswerOptionSingleChoiceClicked(optionClicked, parent) {
  $(optionClicked).toggleClass("answer-option-container-clicked");
  $(".glossary-term").toggleClass("glossary-term-clicked");
  $(optionClicked).find(".checkbox-off").toggleClass("checkbox"); //Reset siblings

  var siblings = $(optionClicked).siblings();

  if($(optionClicked).parent().get(0).classList.contains('col-10')){
    siblings = $(optionClicked).parent().parent().siblings().find('button')
  }

  siblings.removeClass("answer-option-container-clicked");
  siblings.find(".checkbox-off").removeClass("checkbox"); //Set value to parent or reset if this value was already selected

  if (parent.text == optionClicked.value) {
    parent.text = "";
  } else {
    parent.text = optionClicked.value; //Hide "required" flag if it was shown
  }

  $(parent).find(".required-answer-flag").hide();

  checkIfAllRequiredQuestionsAreAnswered();
}

var exclusiveChoiceCurrentlySelected = false;

function onAnswerOptionMultipleChoiceClicked(optionClicked, parent) {
  //Check if this option is currently selected
  var optionAlreadySelected = false;
  if (optionClicked.classList.contains("answer-option-container-clicked")) optionAlreadySelected = true; //Toggle classes for visual selection

  $(optionClicked).toggleClass("answer-option-container-clicked");
  $(".glossary-term").toggleClass("glossary-term-clicked");
  $(optionClicked).find(".checkbox-off").toggleClass("checkbox"); //Depending on whether option is exclusive or not, reset other options and values

  // JD - pretty sure data-exclusive means if only one option can be selected
  if (optionClicked.getAttribute("data-exclusive") == "true") {
    if (!exclusiveChoiceCurrentlySelected) exclusiveChoiceCurrentlySelected = true; //Because it is a exclusive answer, reset all current values

    $(parent).data("values", []); //If this option was already selected, do nothing else
    //If it wasn' do the following:

    if (!optionAlreadySelected) {
      //Reset siblings
      var siblings = $(optionClicked).siblings();
      if($(optionClicked).parent().get(0).classList.contains('col-10')){
        siblings = $(optionClicked).parent().parent().siblings();
        $(siblings).find('button').removeClass("answer-option-container-clicked");
      }

      siblings.removeClass("answer-option-container-clicked");
      siblings.find(".checkbox-off").removeClass("checkbox"); //Add new value

      var valuesArray = $(parent).data("values");
      valuesArray.push(optionClicked.value);
      $(parent).data("values", valuesArray);
    }
  } else {
    //If this options is currently selected, just unselect it
    if (optionAlreadySelected) {
      //remove value from parent
      if ($(parent).data("values")) {
        var index = $(parent).data("values").indexOf(optionClicked.value);

        if (index > -1) {
          $(parent).data("values").splice(index, 1);
        }
      }
    }
    else {
      //If option wasn't currently selected
      //Disable any exclusive options if selected
      if (exclusiveChoiceCurrentlySelected) {
        var _siblings = $(optionClicked).siblings();

        if($(optionClicked).parent().get(0).classList.contains('col-10')){
          _siblings = $(optionClicked).parent().parent().siblings().find('button');
        }

        for (var _index = 0; _index < _siblings.length; _index++) {
          if (_siblings[_index].getAttribute("data-exclusive") == "true") {
            $(_siblings[_index]).removeClass("answer-option-container-clicked");
            $(_siblings[_index]).find(".checkbox-off").removeClass("checkbox");
          }
        }

        $(parent).data("values", []);
        exclusiveChoiceCurrentlySelected = false;
      } //Set value to parent


      if ($(parent).data("values") == undefined) $(parent).data("values", []);

      var _valuesArray = $(parent).data("values");

      _valuesArray.push(optionClicked.value);

      $(parent).data("values", _valuesArray);
    }
  }
  $(parent).find(".required-answer-flag").hide();

  checkIfAllRequiredQuestionsAreAnswered();

} //Big tooltip


function showTooltip(object) {
  $("#glossary-tooltip").html(object.title);
  $("#glossary-tooltip").toggleClass("glossary-tooltip-active");
  $("#glossary-tooltip").height($("#glossary-tooltip").width());
}

function hideTooltip() {
  $("#glossary-tooltip").toggleClass("glossary-tooltip-active");
} //Chat window


$("#web-chat-bubble").mouseenter(function () {
  $("#web-chat-bubble").animate({
    width: "230px",
    height: "150px"
  }, 500, onEnded);

  function onEnded() {
    $("#web-chat-bubble-content").css("display", "block");
  }
});
$("#web-chat-bubble").mouseleave(function () {
  $("#web-chat-bubble-content").css("display", "none");
  $("#web-chat-bubble").animate({
    width: "70px",
    height: "55px"
  }, 500);
});
//# sourceMappingURL=screener-animations.js.map